module.exports = __webpack_public_path__ + "static/machine05-328c2201901f98a7b5b5fc1dea7c56fb.png";